import type { DuckKind } from './Duck';

export type Difficulty = 'rubber' | 'normal' | 'nightmare';
export type GameMode = 'campaign' | 'horde';

export type DifficultyProfile = {
  label: string;
  enemyHealth: number;
  enemyDamage: number;
  enemySpeed: number;
  ammo: number;
  score: number;
};

export const DIFFICULTIES: Record<Difficulty, DifficultyProfile> = {
  rubber: { label: 'Bagnetto', enemyHealth: 0.78, enemyDamage: 0.68, enemySpeed: 0.9, ammo: 1.3, score: 0.75 },
  normal: { label: 'Bonifica', enemyHealth: 1, enemyDamage: 1, enemySpeed: 1, ammo: 1, score: 1 },
  nightmare: { label: 'Quackmare', enemyHealth: 1.28, enemyDamage: 1.34, enemySpeed: 1.12, ammo: 0.78, score: 1.5 },
};

const REGULAR_ROTATION: readonly DuckKind[] = [
  'standard', 'standard', 'kamikaze', 'standard', 'medic', 'armored', 'standard', 'sniper',
];

export const getDuckKindForSpawn = (
  index: number,
  levelIndex: number,
  boss = false,
): DuckKind => {
  if (boss) return 'boss';
  const unlocked = levelIndex === 0
    ? REGULAR_ROTATION.filter((kind) => kind !== 'sniper')
    : REGULAR_ROTATION;
  return unlocked[(index + levelIndex * 3) % unlocked.length];
};

export const getHordeComposition = (wave: number, playerCount: number): DuckKind[] => {
  const count = Math.min(42, 5 + wave * 2 + Math.max(0, playerCount - 1) * 3);
  return Array.from({ length: count }, (_, index) => {
    if (wave % 5 === 0 && index === count - 1) return 'boss';
    const cycle = getDuckKindForSpawn(index + wave * 5, Math.min(2, Math.floor(wave / 3)));
    if (wave < 2 && cycle === 'armored') return 'standard';
    if (wave < 3 && (cycle === 'medic' || cycle === 'sniper')) return 'kamikaze';
    return cycle;
  });
};

export const calculateScore = (input: {
  kills: number;
  elapsedSeconds: number;
  secrets: number;
  revives: number;
  difficulty: Difficulty;
  victory: boolean;
}): number => {
  const base = input.kills * 100 + input.secrets * 750 + input.revives * 500;
  const timeBonus = input.victory ? Math.max(0, 18_000 - Math.round(input.elapsedSeconds * 12)) : 0;
  const victoryBonus = input.victory ? 5_000 : 0;
  return Math.max(0, Math.round((base + timeBonus + victoryBonus) * DIFFICULTIES[input.difficulty].score));
};
